module.exports = __webpack_public_path__ + "img/elegant@2x.4f7bb16.jpg";